export { QuarantineTab } from "./QuarantineTab";
